module.exports = " <div class=loading> <div class=windows8> <div class=wBall id=wBall_1> <div class=wInnerBall></div> </div> <div class=wBall id=wBall_2> <div class=wInnerBall></div> </div> <div class=wBall id=wBall_3> <div class=wInnerBall></div> </div> <div class=wBall id=wBall_4> <div class=wInnerBall></div> </div> <div class=wBall id=wBall_5> <div class=wInnerBall></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/shared/Loading.vue
// module id = 172
// module chunks = 0